const translations = {
  "en": {
    "Portfolio Check": "Portfolio Check",
    "Portfolio Summary": "Portfolio Summary"
  },
  "zh-tw": {
    "Portfolio Check": "投資組合檢視",
    "Portfolio Summary": "投資組合摘要"
  }
};

export default translations;
